import css from './header.scss'
import MainButton from '../../components/button/button'
import Logo from '../../components/logo/logo'
import { useHistory } from "react-router-dom";

const Header = () => {
    const history = useHistory();
    return (
        <header className={css.root}>
            <div className="container">
                <div className={css.inner}>
                    <Logo />
                    <nav>
                        <MainButton style={css.mainBtn} onClick={() => {history.push('/landing');}} caption="На главную" />
                    </nav>
                </div>
            </div>
        </header>
    );
}

export default Header;